module.exports = __webpack_public_path__ + "static/media/11.fbc1a211.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/11.png
// module id = 863
// module chunks = 0